/**
 * KingStar global behaviour (loaded from snippets/kingstar-global.liquid).
 * Delegated so it keeps working after Horizon re-renders the cart drawer / cart page.
 */

// Cart attributes (snippets/kingstar-delivery-time.liquid): save as soon as the customer picks a value.
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.dataset.kingstarCartAttribute) return;

  select.disabled = true;
  fetch(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { [select.dataset.kingstarCartAttribute]: select.value } }),
  })
    .catch((error) => console.warn('[kingstar] cart attribute not saved', error))
    .finally(() => {
      select.disabled = false;
    });
});

// Card image swipe (snippets/kingstar-card-media.liquid): light up the bar of the image in view.
// Scroll events do not bubble, so listen in the capture phase to cover cards added later.
document.addEventListener(
  'scroll',
  (event) => {
    const slides = event.target;
    if (!(slides instanceof HTMLElement) || !slides.hasAttribute('data-kingstar-swipe')) return;

    const bars = slides.parentElement?.querySelectorAll('.kingstar-card__bars > span');
    if (!bars?.length) return;

    const index = Math.round(slides.scrollLeft / slides.clientWidth);
    bars.forEach((bar, i) => bar.toggleAttribute('data-active', i === index));
  },
  { capture: true, passive: true }
);

// READ MORE for collection descriptions (snippets/kingstar-collection-description.liquid).
function kingstarInitReadMore(root = document) {
  root.querySelectorAll('[data-kingstar-readmore]:not([data-ready])').forEach((body) => {
    body.setAttribute('data-ready', '');
    body.setAttribute('data-clamped', '');
    const toggle = body.parentElement?.querySelector('[data-kingstar-readmore-toggle]');
    if (toggle && body.scrollHeight - body.clientHeight > 8) toggle.hidden = false;
    else body.removeAttribute('data-clamped');
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => kingstarInitReadMore());
else kingstarInitReadMore();

document.addEventListener('click', (event) => {
  const toggle = event.target instanceof Element ? event.target.closest('[data-kingstar-readmore-toggle]') : null;
  const body = toggle?.parentElement?.querySelector('[data-kingstar-readmore]');
  if (!body) return;
  toggle.textContent = body.toggleAttribute('data-clamped') ? 'More +' : 'Less −';
});
